(function () {
    'use strict';

    function onReady(fn) {
        if (document.readyState !== 'loading') fn();
        else document.addEventListener('DOMContentLoaded', fn);
    }

    onReady(function () {

        // Announcement Bar Close
        document.addEventListener('click', function (e) {
            var btn = e.target.closest('.announcement-bar__close');
            if (!btn) return;
            var bar = btn.closest('.announcement-bar');
            if (bar) {
                bar.style.maxHeight = bar.scrollHeight + 'px';
                bar.style.overflow = 'hidden';
                bar.style.transition = 'max-height 0.3s ease, opacity 0.3s ease';
                requestAnimationFrame(function () {
                    bar.style.maxHeight = '0';
                    bar.style.opacity = '0';
                });
                setTimeout(function () { bar.style.display = 'none'; }, 300);
            }
        });

        // Search Dropdown
        var searchInput = document.querySelector('.header-search input[type="text"]');
        var searchDropdown = document.querySelector('.header-search__dropdown');
        if (searchInput && searchDropdown) {
            searchInput.addEventListener('focus', function () {
                searchDropdown.classList.add('active');
                searchDropdown.style.maxHeight = '400px';
                searchDropdown.style.opacity = '1';
            });
            document.addEventListener('click', function (e) {
                if (!e.target.closest('.header-search')) {
                    searchDropdown.classList.remove('active');
                    searchDropdown.style.maxHeight = '0';
                    searchDropdown.style.opacity = '0';
                }
            });
        }

        // Mega Menu - Sidebar Flyout
        var ceSidebar = document.querySelector('.ce-mega-menu__sidebar');
        if (ceSidebar) {
            var ceSidebarRows = ceSidebar.querySelectorAll('.ce-mega-menu__sidebar-row--has-flyout');
            var ceFlyouts = document.querySelectorAll('.ce-mega-menu__flyout');
            var ceFlyoutTimeout = null;

            ceSidebarRows.forEach(function (row) {
                row.addEventListener('mouseenter', function () {
                    if (ceFlyoutTimeout) clearTimeout(ceFlyoutTimeout);
                    var targetId = row.dataset.flyoutTarget;
                    ceSidebarRows.forEach(function (r) { r.classList.remove('active'); });
                    ceFlyouts.forEach(function (f) { f.classList.remove('active'); });
                    row.classList.add('active');
                    var target = document.querySelector('[data-flyout-id="' + targetId + '"]');
                    if (target) target.classList.add('active');
                });
            });

            var ceMegaMenu = document.querySelector('.ce-mega-menu');
            if (ceMegaMenu) {
                ceMegaMenu.addEventListener('mouseleave', function () {
                    ceSidebarRows.forEach(function (r) { r.classList.remove('active'); });
                    ceFlyouts.forEach(function (f) { f.classList.remove('active'); });
                });
            }
        }

        // Mobile Menu Toggle
        document.addEventListener('click', function (e) {
            var toggle = e.target.closest('.mobile-menu-toggle');
            if (!toggle) return;
            var navBar = document.querySelector('.nav-bar');
            var ceMenu = document.querySelector('.ce-mega-menu');
            if (navBar) navBar.classList.toggle('mobile-open');
            if (ceMenu) ceMenu.classList.toggle('mobile-visible');
        });

        // Product Card Hover Effects (Only for Campaign Cards)
        document.addEventListener('mouseenter', function (e) {
            var card = e.target.closest('.product-card--campaign');
            if (!card) return;
            var cart = card.querySelector('.product-card__cart');
            if (cart) { cart.style.maxHeight = cart.scrollHeight + 'px'; cart.style.opacity = '1'; }
        }, true);
        document.addEventListener('mouseleave', function (e) {
            var card = e.target.closest('.product-card--campaign');
            if (!card) return;
            var cart = card.querySelector('.product-card__cart');
            if (cart) { cart.style.maxHeight = '0'; cart.style.opacity = '0'; }
        }, true);

        // Initially hide cart buttons via CSS (max-height) only for Campaign Cards
        document.querySelectorAll('.product-card--campaign .product-card__cart').forEach(function (el) {
            el.style.maxHeight = '0';
            el.style.opacity = '0';
            el.style.overflow = 'hidden';
            el.style.transition = 'max-height 0.2s ease, opacity 0.2s ease';
        });

        // Favorite Button Toggle
        document.addEventListener('click', function (e) {
            var fav = e.target.closest('.product-card__fav');
            if (!fav) return;
            e.preventDefault();
            var icon = fav.querySelector('i');
            if (!icon) return;
            if (icon.classList.contains('lar')) {
                icon.classList.remove('lar', 'la-heart');
                icon.classList.add('las', 'la-heart');
                fav.style.color = '#c62828';
            } else {
                icon.classList.remove('las', 'la-heart');
                icon.classList.add('lar', 'la-heart');
                fav.style.color = '';
            }
        });

        // AJAX Add to Cart
        document.addEventListener('submit', function (e) {
            var form = e.target;
            if (!form.classList.contains('product-card__cart-form')) return;
            e.preventDefault();
            var btn = form.querySelector('.product-card__cart-btn');
            if (!btn) return;
            var originalText = btn.innerHTML;
            btn.innerHTML = '<i class="las la-spinner la-spin"></i> EKLENIYOR...';
            btn.disabled = true;

            fetch('/cart/add.js', {
                method: 'POST',
                body: new FormData(form),
                credentials: 'same-origin'
            })
            .then(function (r) { return r.json(); })
            .then(function () {
                btn.innerHTML = '<i class="las la-check"></i> EKLENDI!';
                btn.style.background = '#2e7d32';
                fetch('/cart.js', { credentials: 'same-origin' })
                    .then(function (r) { return r.json(); })
                    .then(function (cart) {
                        var badge = document.querySelector('.header-action-btn .badge');
                        if (cart.item_count > 0) {
                            if (badge) { badge.textContent = cart.item_count; }
                            else {
                                var cartLink = document.querySelector('.header-action-btn a[href="/cart"]');
                                if (cartLink) {
                                    var b = document.createElement('div');
                                    b.className = 'badge';
                                    b.textContent = cart.item_count;
                                    cartLink.appendChild(b);
                                }
                            }
                        }
                    });
                setTimeout(function () { btn.innerHTML = originalText; btn.style.background = ''; btn.disabled = false; }, 2000);
            })
            .catch(function () {
                btn.innerHTML = '<i class="las la-times"></i> HATA!';
                btn.style.background = '#c62828';
                setTimeout(function () { btn.innerHTML = originalText; btn.style.background = ''; btn.disabled = false; }, 2000);
            });
        });

        // Smooth Scroll
        document.addEventListener('click', function (e) {
            var link = e.target.closest('a[href^="#"]');
            if (!link) return;
            var href = link.getAttribute('href');
            if (href === '#') return;
            var target = document.querySelector(href);
            if (target) {
                e.preventDefault();
                window.scrollTo({ top: target.offsetTop - 100, behavior: 'smooth' });
            }
        });

        // Sticky Header Shadow
        var mainHeader = document.querySelector('.main-header');
        var lastScroll = 0;
        window.addEventListener('scroll', function () {
            var y = window.pageYOffset;
            if (mainHeader) {
                if (y > 200) {
                    mainHeader.style.boxShadow = '0 2px 15px rgba(0,0,0,0.1)';
                } else {
                    mainHeader.style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)';
                }
            }
            lastScroll = y;
        }, { passive: true });

        // Scroll to Top Button
        var scrollTopBtn = null;
        window.addEventListener('scroll', function () {
            if (window.pageYOffset > 500) {
                if (!scrollTopBtn) {
                    scrollTopBtn = document.createElement('button');
                    scrollTopBtn.id = 'scrollTopBtn';
                    scrollTopBtn.innerHTML = '<i class="las la-angle-up"></i>';
                    scrollTopBtn.addEventListener('click', function () {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    });
                    document.body.appendChild(scrollTopBtn);
                }
                scrollTopBtn.style.opacity = '1';
                scrollTopBtn.style.pointerEvents = 'auto';
            } else if (scrollTopBtn) {
                scrollTopBtn.style.opacity = '0';
                scrollTopBtn.style.pointerEvents = 'none';
            }
        }, { passive: true });

        // Lazy Load Images
        if ('IntersectionObserver' in window) {
            var lazyObserver = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        var img = entry.target;
                        if (img.dataset.src) {
                            img.src = img.dataset.src;
                            img.removeAttribute('data-src');
                        }
                        lazyObserver.unobserve(img);
                    }
                });
            });
            document.querySelectorAll('img[data-src]').forEach(function (img) {
                lazyObserver.observe(img);
            });
        }

        // Product Page Quantity
        window.updateQty = function (delta) {
            var qty = document.getElementById('productQty');
            if (!qty) return;
            var v = parseInt(qty.value) + delta;
            if (v < 1) v = 1;
            if (v > 99) v = 99;
            qty.value = v;
            var hidden = document.getElementById('qtyInput');
            if (hidden) hidden.value = v;
        };

        // Cart Page Quantity
        window.updateCartQty = function (index, delta) {
            var input = document.getElementById('updates_' + index);
            if (!input) return;
            var v = parseInt(input.value) + delta;
            if (v < 0) v = 0;
            input.value = v;
        };

        // Initialize all Swiper instances from data attributes
        initSwipers();

        // Newsletter Popup
        initNewsletterPopup();

        // Related Products (API-driven)
        initRelatedProducts();

        // Recently Viewed Products
        initRecentlyViewed();

    }); // end onReady

    function initSwipers() {
        if (typeof Swiper === 'undefined') {
            setTimeout(initSwipers, 100);
            return;
        }

        // Hero Slider
        document.querySelectorAll('.home-promo-grid-swiper').forEach(function (el) {
            if (el.dataset.swiperInit) return;
            new Swiper(el, {
                loop: true,
                autoplay: { delay: 5000, disableOnInteraction: false },
                pagination: { el: el.querySelector('.swiper-pagination'), clickable: true }
            });
            el.dataset.swiperInit = 'true';
        });

        // Hero Triple Slider - Main
        document.querySelectorAll('.hero-triple-main-swiper').forEach(function (el) {
            if (el.dataset.swiperInit) return;
            var delay = 5000;
            var section = el.closest('.hero-triple-slider');
            if (section) {
                var d = parseInt(section.dataset.autoplayDelay);
                if (d) delay = d * 1000;
            }
            new Swiper(el, {
                loop: true,
                autoplay: { delay: delay, disableOnInteraction: false },
                pagination: { el: el.querySelector('.hero-triple-main-pagination'), clickable: true }
            });
            el.dataset.swiperInit = 'true';
        });

        // Hero Triple Slider - Side
        document.querySelectorAll('.hero-triple-side-swiper').forEach(function (el) {
            if (el.dataset.swiperInit) return;
            new Swiper(el, {
                loop: true,
                autoplay: { delay: 4000, disableOnInteraction: false },
                pagination: { el: el.querySelector('.hero-triple-side-pagination'), clickable: true }
            });
            el.dataset.swiperInit = 'true';
        });

        // Product Carousels
        document.querySelectorAll('.product-swiper').forEach(function (el) {
            if (el.dataset.swiperInit) return;
            var desktopSlides = parseInt(el.dataset.desktopSlides) || 6;
            new Swiper(el, {
                slidesPerView: 2,
                spaceBetween: 12,
                navigation: { nextEl: el.querySelector('.swiper-button-next'), prevEl: el.querySelector('.swiper-button-prev') },
                breakpoints: { 480: { slidesPerView: 2 }, 768: { slidesPerView: 3 }, 992: { slidesPerView: 4 }, 1200: { slidesPerView: desktopSlides } }
            });
            el.dataset.swiperInit = 'true';
        });

        // Brand Carousels
        document.querySelectorAll('.brand-swiper').forEach(function (el) {
            if (el.dataset.swiperInit) return;
            new Swiper(el, {
                slidesPerView: 3,
                spaceBetween: 15,
                autoplay: { delay: 3000, disableOnInteraction: false },
                breakpoints: { 480: { slidesPerView: 4 }, 768: { slidesPerView: 5 }, 992: { slidesPerView: 6 }, 1200: { slidesPerView: 8 } }
            });
            el.dataset.swiperInit = 'true';
        });

        // Blog Carousels
        document.querySelectorAll('.blog-swiper').forEach(function (el) {
            if (el.dataset.swiperInit) return;
            new Swiper(el, {
                slidesPerView: 1,
                spaceBetween: 15,
                breakpoints: { 480: { slidesPerView: 2 }, 768: { slidesPerView: 3 }, 992: { slidesPerView: 4 } }
            });
            el.dataset.swiperInit = 'true';
        });
    }

    function initNewsletterPopup() {
        var popup = document.getElementById('newsletter-popup');
        if (!popup) return;
        var delay = parseInt(popup.dataset.popupDelay) || 5;

        setTimeout(function () {
            if (!localStorage.getItem('newsletterPopupClosed')) {
                popup.style.display = 'flex';
            }
        }, delay * 1000);

        popup.addEventListener('click', function (e) {
            if (e.target.closest('[data-popup-close]')) {
                popup.style.display = 'none';
            }
        });

        var dontShow = document.querySelector('[data-popup-dont-show]');
        if (dontShow) {
            dontShow.addEventListener('change', function () {
                if (this.checked) {
                    localStorage.setItem('newsletterPopupClosed', 'true');
                }
            });
        }
    }

    function initRelatedProducts() {
        document.querySelectorAll('[data-intent="related"]').forEach(function (el) {
            var productId = el.dataset.productId;
            var limit = el.dataset.productLimit || 15;
            var desktopSlides = parseInt(el.dataset.desktopSlides) || 6;
            if (!productId) return;

            fetch('/recommendations/products?product_id=' + productId + '&limit=' + limit + '&intent=related')
                .then(function (r) { return r.json(); })
                .then(function (data) {
                    if (data.products && data.products.length > 0) {
                        var wrapper = el.querySelector('.swiper-wrapper');
                        wrapper.innerHTML = '';
                        data.products.forEach(function (product) {
                            var slide = document.createElement('div');
                            slide.className = 'swiper-slide';
                            slide.innerHTML =
                                '<div class="product-card">' +
                                '<a href="' + product.url + '" class="product-card__link">' +
                                '<div class="product-card__image">' +
                                '<img src="' + product.featured_image + '" alt="' + product.title + '" loading="lazy">' +
                                '</div>' +
                                '<div class="product-card__info">' +
                                '<div class="product-card__title">' + product.title + '</div>' +
                                '<div class="product-card__prices">' +
                                (product.price ? '<div class="product-card__price">' + product.price + '</div>' : '') +
                                (product.compare_at_price ? '<div class="product-card__old-price">' + product.compare_at_price + '</div>' : '') +
                                '</div></div></a></div>';
                            wrapper.appendChild(slide);
                        });

                        if (typeof Swiper !== 'undefined') {
                            new Swiper(el, {
                                slidesPerView: 2,
                                spaceBetween: 12,
                                navigation: { nextEl: el.querySelector('.swiper-button-next'), prevEl: el.querySelector('.swiper-button-prev') },
                                breakpoints: { 480: { slidesPerView: 2 }, 768: { slidesPerView: 3 }, 992: { slidesPerView: 4 }, 1200: { slidesPerView: desktopSlides } }
                            });
                        }
                    } else {
                        el.style.display = 'none';
                    }
                })
                .catch(function () { el.style.display = 'none'; });
        });
    }

    function initRecentlyViewed() {
        var trackers = document.querySelectorAll('[data-recently-viewed-track]');
        trackers.forEach(function (t) {
            var handle = t.dataset.productHandle;
            var id = t.dataset.productId;
            if (handle) {
                var rv = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');
                rv = rv.filter(function (p) { return p.handle !== handle; });
                rv.unshift({ id: id, handle: handle, viewedAt: new Date().toISOString() });
                rv = rv.slice(0, 20);
                localStorage.setItem('recentlyViewedProducts', JSON.stringify(rv));
            }
        });

        document.querySelectorAll('[data-recently-viewed]').forEach(function (el) {
            var desktopSlides = parseInt(el.dataset.desktopSlides) || 6;
            var limit = el.dataset.productLimit || 10;
            var rv = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');

            if (rv.length === 0) { el.style.display = 'none'; return; }
            rv = rv.slice(0, limit);

            fetch('/recommendations/products?product_id=' + rv[0].id + '&limit=' + limit + '&intent=related')
                .then(function (r) { return r.json(); })
                .then(function (data) {
                    if (data.products && data.products.length > 0) {
                        var wrapper = el.querySelector('.swiper-wrapper');
                        wrapper.innerHTML = '';
                        data.products.forEach(function (product) {
                            var slide = document.createElement('div');
                            slide.className = 'swiper-slide';
                            slide.innerHTML =
                                '<div class="product-card">' +
                                '<a href="' + product.url + '" class="product-card__link">' +
                                '<div class="product-card__image">' +
                                '<img src="' + product.featured_image + '" alt="' + product.title + '" loading="lazy">' +
                                '</div>' +
                                '<div class="product-card__info">' +
                                '<div class="product-card__title">' + product.title + '</div>' +
                                '<div class="product-card__prices">' +
                                (product.price ? '<div class="product-card__price">' + product.price + '</div>' : '') +
                                (product.compare_at_price ? '<div class="product-card__old-price">' + product.compare_at_price + '</div>' : '') +
                                '</div></div></a></div>';
                            wrapper.appendChild(slide);
                        });

                        if (typeof Swiper !== 'undefined') {
                            new Swiper(el, {
                                slidesPerView: 2,
                                spaceBetween: 12,
                                navigation: { nextEl: el.querySelector('.swiper-button-next'), prevEl: el.querySelector('.swiper-button-prev') },
                                breakpoints: { 480: { slidesPerView: 2 }, 768: { slidesPerView: 3 }, 992: { slidesPerView: 4 }, 1200: { slidesPerView: desktopSlides } }
                            });
                        }
                    } else {
                        el.style.display = 'none';
                    }
                })
                .catch(function () { el.style.display = 'none'; });
        });
    }

    // Product Page Tabs
    document.addEventListener('click', function (e) {
        var tabLink = e.target.closest('.product-page__tabs-link');
        if (!tabLink) return;
        var tabId = tabLink.getAttribute('data-tab');
        if (!tabId) return;

        var nav = tabLink.closest('.product-page__tabs-nav');
        if (nav) {
            nav.querySelectorAll('.product-page__tabs-link').forEach(function (l) { l.classList.remove('active'); });
        }
        tabLink.classList.add('active');

        var container = tabLink.closest('.product-page__tabs');
        if (container) {
            container.querySelectorAll('.product-page__tab-content').forEach(function (c) { c.classList.remove('active'); });
            var target = container.querySelector('#' + tabId);
            if (target) target.classList.add('active');
        }
    });

    // Quantity sync on product page
    var qtyInput = document.getElementById('productQty');
    var qtyHidden = document.getElementById('qtyInput');
    if (qtyInput && qtyHidden) {
        qtyInput.addEventListener('input', function () {
            qtyHidden.value = qtyInput.value;
        });
    }

    // Collection view toggle
    document.addEventListener('click', function (e) {
        var viewBtn = e.target.closest('.collection-page__view-btn');
        if (!viewBtn) return;
        var toolbar = viewBtn.closest('.collection-page__view-toggle');
        if (toolbar) {
            toolbar.querySelectorAll('.collection-page__view-btn').forEach(function (b) { b.classList.remove('active'); });
        }
        viewBtn.classList.add('active');
    });

    // Collapsible sidebar filters
    document.addEventListener('click', function (e) {
        var title = e.target.closest('.collection-page__sidebar-title--collapsible');
        if (!title) return;
        var box = title.closest('.collection-page__sidebar-box');
        if (!box) return;
        
        box.classList.toggle('active');
        var content = box.querySelector('.collection-page__sidebar-collapse-content');
        if (content) {
            if (box.classList.contains('active')) {
                content.style.maxHeight = content.scrollHeight + 'px';
            } else {
                content.style.maxHeight = '0px';
            }
        }
    });

    // Price Range Filter Logic
    var priceMin = document.getElementById('priceMin');
    var priceMax = document.getElementById('priceMax');
    var priceMinVal = document.getElementById('priceMinVal');
    var priceMaxVal = document.getElementById('priceMaxVal');
    var priceBtn = document.querySelector('.collection-page__price-btn');

    if (priceMin && priceMax && priceMinVal && priceMaxVal) {
        var updateLabels = function () {
            priceMinVal.textContent = parseInt(priceMin.value).toLocaleString('tr-TR');
            priceMaxVal.textContent = parseInt(priceMax.value).toLocaleString('tr-TR');
        };

        // Parse from URL parameters on load to override the initial state
        var urlParams = new URLSearchParams(window.location.search);
        var gte = urlParams.get('filter.v.price.gte');
        var lte = urlParams.get('filter.v.price.lte');
        if (gte !== null) {
            priceMin.value = gte;
        }
        if (lte !== null) {
            priceMax.value = lte;
        }
        updateLabels();

        priceMin.addEventListener('input', function () {
            var minVal = parseInt(priceMin.value);
            var maxVal = parseInt(priceMax.value);
            if (minVal >= maxVal) {
                priceMin.value = maxVal - 1;
            }
            updateLabels();
        });

        priceMax.addEventListener('input', function () {
            var minVal = parseInt(priceMin.value);
            var maxVal = parseInt(priceMax.value);
            if (maxVal <= minVal) {
                priceMax.value = minVal + 1;
            }
            updateLabels();
        });

        if (priceBtn) {
            priceBtn.addEventListener('click', function () {
                var minVal = parseInt(priceMin.value);
                var maxVal = parseInt(priceMax.value);
                var maxLimit = parseInt(priceMax.max);
                var url = new URL(window.location.href);
                
                if (minVal === 0) {
                    url.searchParams.delete('filter.v.price.gte');
                } else {
                    url.searchParams.set('filter.v.price.gte', minVal);
                }
                
                if (maxVal === maxLimit) {
                    url.searchParams.delete('filter.v.price.lte');
                } else {
                    url.searchParams.set('filter.v.price.lte', maxVal);
                }
                
                url.searchParams.delete('page'); // Reset to page 1
                window.location.href = url.pathname + url.search;
            });
        }
    }

    // Re-initialize scripts on Shopify section load (Theme Editor)
    document.addEventListener('shopify:section:load', function () {
        initSwipers();
    });

})();
